import React from 'react'

const SvgComponent = function (props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 58 69"
      className="design-iconfont"
      {...props}
    >
      <defs>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="c">
          <stop stopColor="#F9945B" offset="0%" />
          <stop stopColor="#F94B23" offset="100%" />
        </linearGradient>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="b">
          <stop stopColor="#FFB083" offset="0%" />
          <stop stopColor="#FF7A5C" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="15.078%"
          y1="29.623%"
          x2="91.089%"
          y2="71.948%"
          id="e"
        >
          <stop stopColor="#FFE9E1" offset="0%" />
          <stop stopColor="#FFE9E1" offset="100%" />
        </linearGradient>
        <filter
          x="-44%"
          y="-37%"
          width="187.9%"
          height="173.9%"
          filterUnits="objectBoundingBox"
          id="a"
        >
          <feOffset dy={3} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            stdDeviation={5}
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter
          x="-48%"
          y="-63.2%"
          width="196%"
          height="226.3%"
          filterUnits="objectBoundingBox"
          id="d"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            stdDeviation={2}
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0.976470588 0 0 0 0 0.321568627 0 0 0 0 0.156862745 0 0 0 1 0"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g filter="url(#a)" fill="none" fillRule="evenodd">
        <path
          d="M29 4c6.35 0 12.1 2.59 16.261 6.774A23.132 23.132 0 0 1 52 27.136c0 5.526-3.422 12.305-7.652 18.275C38.784 53.26 31.73 60 29 60c-2.73 0-9.784-6.74-15.348-14.59C9.422 39.442 6 32.663 6 27.137c0-6.39 2.575-12.174 6.739-16.362C16.9 6.59 22.649 4 29 4Z"
          stroke="url(#b)"
          strokeWidth={2}
          fill="url(#c)"
        />
        <g
          filter="url(#d)"
          transform="translate(17 18)"
          fill="url(#e)"
          fillRule="nonzero"
        >
          <path d="M1.46 7.453h1.31v6.697H1.46V7.453Zm.676 5.888c.56 0 1.065.339 1.278.855.213.521.097 1.116-.301 1.516a1.383 1.383 0 0 1-2.36-.981c0-.367.143-.72.407-.981.259-.265.61-.41.976-.41Zm4.351-4.093h12.271a.74.74 0 0 1 .532.224.755.755 0 0 1 .223.534v6.367c0 .418-.357.758-.755 1.06 0 0-3.203 1.567-6.337 1.567-3 0-5.934-1.567-5.934-1.567-.518-.321-.754-.744-.754-1.163v-6.264c0-.2.078-.395.222-.534a.74.74 0 0 1 .532-.224Zm1.231.986h9.809a.59.59 0 0 1 .602.577v4.85c0 .32-.056.572-.602.81 0 0-2.56 1.194-5.064 1.194-2.398 0-4.745-1.195-4.745-1.195-.523-.176-.601-.567-.601-.883V10.81c0-.321.268-.577.601-.577ZM13.523.227 24.576 6.17c.565.302.565.795 0 1.102l-11.053 5.943c-.565.302-1.481.302-2.046 0L.424 7.272c-.565-.302-.565-.795 0-1.102L11.477.227c.565-.303 1.481-.303 2.046 0Zm-.185 1.46L22.29 6.22c.458.232.458.61 0 .842l-8.952 4.534c-.458.232-1.199.232-1.657 0L2.733 7.063c-.458-.233-.458-.61 0-.842l8.952-4.534c.454-.228 1.2-.228 1.653 0Z" />
        </g>
      </g>
    </svg>
  )
}
export default SvgComponent
